export const GET_PROSPECTS_REQUEST = 'GET_PROSPECTS_REQUEST';
export const GET_PROSPECTS_SUCCESS = 'GET_PROSPECTS_SUCCESS';
export const GET_PROSPECTS_FAILED = 'GET_PROSPECTS_FAILED';

export const SET_SELECTED_PROSPECT = 'SET_SELECTED_PROSPECT';
export const SELECT_ALL_PROSPECTS = 'SELECT_ALL_PROSPECTS';
